import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { Direction, TabPanel, Tabs } from '../../../components/molecules/Tabs';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Statistics } from '../ContentSearchStatistics.types';
import { ContentSearchStatisticsTable } from '../partials/ContentSearchStatisticsTable';

export type ContentSearchStatisticsViewProps = {
  last7Days: Statistics[];
  last30Days: Statistics[];
  last365Days: Statistics[];
};

function ContentSearchStatisticsDefault({ last7Days, last30Days, last365Days }: ContentSearchStatisticsViewProps) {
  const { t } = useSonTranslation('ContentSearchStatistics');

  return (
    <Tabs
      initialActiveTab="content-search-statistics-tab-last7Days"
      direction={Direction.VERTICAL}
      label={t('tabs.label')}
    >
      <TabPanel buttonLabel={t('tabs.button.last7Days')} id="content-search-statistics-tab-last7Days">
        <ContentSearchStatisticsTable statistics={last7Days} type="last7Days" />
      </TabPanel>
      <TabPanel buttonLabel={t('tabs.button.last30Days')} id="content-search-statistics-tab-last30Days">
        <ContentSearchStatisticsTable statistics={last30Days} type="last30Days" />
      </TabPanel>
      <TabPanel buttonLabel={t('tabs.button.last365Days')} id="content-search-statistics-tab-last365Days">
        <ContentSearchStatisticsTable statistics={last365Days} type="last365Days" />
      </TabPanel>
    </Tabs>
  );
}

export const ContentSearchStatisticsDefaultView = asView(ContentSearchStatisticsDefault);
export type ContentSearchStatisticsDefaultView = ComponentProps<typeof ContentSearchStatisticsDefaultView>;
